<template>
    <div id="chart" class="chart-content">
        <div class="chart-title">{{ title }}</div>
        <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    name: "barChart",
    props: ["nameArticles", "viewsArticles", "title"],
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            series: [{
                data: [],
            }],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    width: '100%',
                    toolbar: {
                        show: false,
                    },
                },
                colors: ['#333333'],
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        borderRadiusApplication: 'end',
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: [],
                    labels: {
                        show: true,
                        trim: false,
                        hideOverlappingLabels: true,
                        maxHeight: 120,
                    },
                    axisBorder: {
                        show: false,
                    },
                }
            },
        };
    },
    watch: {
        nameArticles(newNames) {
            this.chartOptions.xaxis.categories = newNames;
            this.updateChart();
        },
        viewsArticles(newViews) {
            this.series = [{ data: newViews }];
            this.updateChart();
        }
    },
    methods: {
        updateChart() {
            this.$nextTick(() => {
                this.chartOptions = { ...this.chartOptions };
                this.series = [...this.series];
            });
        }
    },
    mounted() {
        this.getNamesAndViews();
        this.updateChart(); // Atualize o gráfico após inicializar os dados
    },
};
</script>

<style>
.chart-title {
    display: flex;
    justify-content: center;
    font-size: 1rem;
    align-items: center;
    padding-top: 2px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.chart-content {
    width: 100%;
}
</style>